import Home from '../views/Home.vue'
export default {
  path: '/mine',
  name: '信息完善',
  component: Home,
  iconCls: 'el-icon-user-solid',
  roles: ['AppUser'],
  hidden: true,
  children: [
    {
      path: '/mine/set',
      component: () =>
                import('../views/mine/set/index'),
      name: '信息完善',
      hidden: true
    },
    {
      path: '/mine/collect',
      component: () =>
                import('../views/mine/collect/index'),
      name: '我的收藏',
      hidden: true
    },
    {
      path: '/mine/course',
      component: () =>
                import('../views/mine/course/index'),
      name: '我的排课',
      hidden: true
    }
  ]
}

